import { styled } from "styled-components";
import {
  IsDarkModeProp,
  NavbarProps,
  NavMenuProps,
  SwitchProps,
} from "../common/types";
import CircleBtn from "./Circlebtn";
import animIconDark from "../../assets/images/animDark.png";
import animIconLight from "../../assets/images/animLight.png";
import instaDark from "../../assets/images/instaDark.png";
import instaLight from "../../assets/images/instaLight.png";
import gitDark from "../../assets/images/gitDark.png";
import gitLight from "../../assets/images/gitLight.png";
import lightmode from "../../assets/images/switchLight.png";
import darkmode from "../../assets/images/switchDark.png";
import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import styles from "../ui/Animation/style.module.scss";
import useScrollTriggerAnimation from "../../hooks/useScrollTriggerAnim";
import { useTheme as styledTheme } from "styled-components";
import { git, insta } from "../../config/variables";

const Icondiv = styled.div`
  color: ${({ theme }) => theme.text};
  // border: 1px solid red;
  cursor: pointer;
`;

function AnimIcon({ isDarkMode }: IsDarkModeProp) {
  return (
    <Icondiv>
      <img
        className="App-icon-size1"
        src={isDarkMode ? animIconLight : animIconDark}
        alt="Anim"
      />
      <span className="App-header-text-style">Anim</span>
    </Icondiv>
  );
}

const SocialMedia = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media (max-width: 320px) {
    flex-direction: column;
  }
`;

const SocialMediaContact = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin: 1rem;

  @media (min-width: 769px) {
    flex-direction: column;
  }

  @media (max-width: 320px) {
    flex-direction: column;
  }
`;

export const openSocialLink = (link: string) => {
  window.open(link, "_blank");
};

function SocialIcons({ isDarkMode }: IsDarkModeProp) {
  const location = useLocation();
  const isContactPage = location.pathname === "/contact";

  return isContactPage ? (
    <SocialMediaContact>
      <CircleBtn
        onClick={() => openSocialLink(insta)}
        $size="70px"
        $imageUrl={isDarkMode ? instaDark : instaLight}
        $imgSize="24px"
        $text="Instagram"
        $magneticMargin="1rem"
        $magneticBorderRadius="50%"
      />

      <CircleBtn
        onClick={() => openSocialLink(git)}
        $size="70px"
        $imageUrl={isDarkMode ? gitDark : gitLight}
        $imgSize="24px"
        $text="Github"
        $magneticMargin="1rem"
        $magneticBorderRadius="50%"
      />
    </SocialMediaContact>
  ) : (
    <SocialMedia>
      <CircleBtn
        onClick={() => openSocialLink(insta)}
        $size="70px"
        $imageUrl={isDarkMode ? instaDark : instaLight}
        $imgSize="24px"
        $text="Instagram"
        $magneticMargin="1rem"
        $magneticBorderRadius="50%"
      />

      <CircleBtn
        onClick={() => openSocialLink(git)}
        $size="70px"
        $imageUrl={isDarkMode ? gitDark : gitLight}
        $imgSize="24px"
        $text="Github"
        $magneticMargin="1rem"
        $magneticBorderRadius="50%"
      />
    </SocialMedia>
  );
}

const Switchbtn = styled.button<SwitchProps>`
  background: none;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  margin-left: ${({ $marginLeft }) => $marginLeft || "1rem"};

  img {
    width: 48px;
    height: 48px;
  }
`;

function Switch({ isDarkMode, toggleTheme, $marginLeft }: NavbarProps) {
  return (
    <Switchbtn onClick={toggleTheme} $marginLeft={$marginLeft}>
      <img src={isDarkMode ? lightmode : darkmode} alt="Theme Switch" />
    </Switchbtn>
  );
}

//Menu image button
function MenuBtn({ toggleMenu, isSideMenuOpen }: NavMenuProps) {
  const menuButtonRef = useRef(null);
  // console.log(" menuButtonRef", menuButtonRef.current); check this out later
  useScrollTriggerAnimation(menuButtonRef);

  return (
    <div
      ref={menuButtonRef}
      className={styles.headerButtonContainer}
      style={{
        overflow: "visible",
        top: "20px",
        right: "30px",
      }}
    >
      <CircleBtn
        onClick={toggleMenu}
        $size="76px"
        $zindex={1001}
        $magneticBorderRadius="50%"
        // $magneticBorder="1px solid red"
        $magneticZindex={1002}
        className="menuCrlBtn"
      >
        <div
          className={`menuCrlBtn imgPresent ${styles.burger} ${
            isSideMenuOpen ? styles.burgerActive : ""
          }`}
        ></div>
      </CircleBtn>
    </div>
  );
}

function MenuBtnSmall({
  isDarkMode,
  toggleMenu,
  isSideMenuOpen,
}: NavMenuProps) {
  const styledComponentTheme = styledTheme();

  return (
    <CircleBtn
      $size="60px"
      $bgColor={"transparent"}
      $maxTranslation={7}
      onClick={toggleMenu}
      className="menuCrlBtn" //Check if the click is outside the side menu and not on any of the buttons
      $magneticBorderRadius="50%"
      $transition="color 1s ease-out"
      $color={
        !isDarkMode && isSideMenuOpen
          ? "white"
          : styledComponentTheme.circularIconBg
      }
    >
      <div
        className={`menuCrlBtn ${styles.burger} ${
          isSideMenuOpen ? styles.burgerActive : ""
        } `}
      ></div>
    </CircleBtn>
  );
}


function DashboardMenu({
  toggleMenu,
  isSideMenuOpen,
}: NavMenuProps) {
  const styledComponentTheme = styledTheme();

  return (
    <div  className={styles.DashboardMenu}   style={{
      position: "absolute",
      top: "80px",
      left: "30px",
      zIndex: 1001,
    }}
  >
          <CircleBtn
      $size="76px"
      $bgColor={"transparent"}
      className="menuCrlBtn"
      // $maxTranslation={2}
      onClick={toggleMenu}
      $magneticBorderRadius="50%"
      $magneticBorder={`0.5px solid ${styledComponentTheme.text}`}
      $transition="color 1s ease-out"
      $color={styledComponentTheme.text}
    >
      <div
        className={`imgPresent menuCrlBtn ${styles.burger} ${
          isSideMenuOpen ? styles.burgerActive : ""
        } `}
      ></div>
    </CircleBtn>
    </div>

  );
}

const MemoizedAnimIcon = React.memo(AnimIcon);
const MemoizedSocialIcons = React.memo(SocialIcons);
const MemoizedSwitch = React.memo(Switch);
const MemoizedMenuBtn = React.memo(MenuBtn);
const MemoizedSmMenuBtn = React.memo(MenuBtnSmall);
const MemoizedDashboardMenuBtn = React.memo(DashboardMenu);

export {
  MemoizedAnimIcon as AnimIcon,
  MemoizedSocialIcons as SocialIcons,
  MemoizedSwitch as Switch,
  MemoizedMenuBtn as MenuBtn,
  MemoizedSmMenuBtn as MenuBtnSmall,
  MemoizedDashboardMenuBtn as DashboardMenu,
};
